export default __webpack_public_path__ + "static/media/cognitive-badge.ca472bf0.svg";